<template>
  <div class="table_content">
    <div class="company_table">
      <el-table
        ref="table"
        size="small"
        height="100%"
        header-cell-class-name="brand-table-header-cell"
        cell-class-name="brand-table-cell"
        v-loading="loading"
        :data="companyList"
      >
        <el-table-column label="企业" prop="enterpriseName" width="100">
        </el-table-column>
        <el-table-column label="企业logo" prop="enterpriseLogo">
          <template v-slot="scope">
            <div style="height: 100px">
              <el-image
                class="logo"
                :src="
                  scope.row.enterpriseLogo.replace(
                    'http://gov.eagle.datastory.com.cn',
                    'https://soujian.datatell.com.cn'
                  )
                "
                :preview-src-list="[
                  scope.row.enterpriseLogo.replace(
                    'http://gov.eagle.datastory.com.cn',
                    'https://soujian.datatell.com.cn'
                  ),
                ]"
                fit="fill"
                lazy
                v-if="scope.row.enterpriseLogo"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!-- <svg v-else :width="100" :height="100">
                <a :xlink:special="scope.row.enterpriseLogo"></a>
                 scope.row.enterpriseLogo.split('.').pop() !== 'svg'
              </svg> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime"
          :formatter="formaterTime"
        >
        </el-table-column>
        <el-table-column
          label="添加时间"
          prop="createTime"
          :formatter="formaterTime"
        >
        </el-table-column>
        <el-table-column label="操作" :width="150">
          <template v-slot="scope">
            <el-button
              class="no-margin center-children"
              type="text"
              size="small"
              @click="toJust(scope.row)"
              >权限
            </el-button>
            |
            <el-button
              class="no-margin center-children"
              type="text"
              size="small"
              @click="toEdit(scope.row)"
            >
              编辑
            </el-button>
            |
            <el-popconfirm title="确定删除吗？" @confirm="toDel(scope.row)">
              <el-button
                slot="reference"
                class="no-margin center-children"
                type="text"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagination" class="pagination">
      <el-pagination
        :current-page="params.page"
        :page-size="params.size"
        :total="params.total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 列表数据
    companyList: {
      type: Array,
      default: () => [],
    },
    // 分页器数据
    params: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0,
        };
      },
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changePage(page) {
      this.$emit("change-page", page);
    },
    formaterTime(row, column, cellValue, index) {
      // if (row.companyStatus === 1) {
      //   return "永久";
      // }
      const newTime = this.$moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return newTime;
    },
    // 跳转编辑弹窗
    toEdit(row) {
      //   console.log("您点击了编辑");
      this.$emit("edit-company", row);
    },
    // 跳转权限弹窗
    toJust(row) {
      this.$emit("just-company", row);
    },
    // 点击删除触发事件
    toDel(row) {
      //   console.log("您点击了删除", row);
      this.$http({
        url: `/enterprise/delete?id=${row.enterpriseId}`,
        method: "delete",
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除账号成功",
              type: "success",
            });
            if (this.companyList.length === 1 && this.params.page !== 1) {
              this.$emit("change-page", this.params.page - 1);
            } else {
              this.$emit("update");
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "删除账号失败",
            type: "error",
          });
        });
    },
  },
};
</script>


<style lang="scss">
.no-margin {
  margin: 0;
}
.center-children {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.pagination {
  text-align: right;
}
.table_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  .company_table {
    flex: 1;
    height: 0;
  }
  .pagination {
    height: 32px;
  }
  .logo {
    height: 100%;
    width: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/companyManage/companyTable.vue